module.exports = __webpack_public_path__ + "img/l12.7c6ec9cc.jpg";